import React from 'react';
import { View } from 'react-native';
import { Text } from 'react-native-web';
import { textPrimary_13_0 } from '../TextComponent/TextStyle';
//= ========================================================================

const SingleSquareBtn = ({
  globJSON, price, simPlatform,
}) => {
  const { colors } = globJSON.configurations.theme;
  const myStyles = {
    container: {
      width: 101,
      height: 45,
      borderRadius: globJSON.configurations.theme.radius.elements_shape_square ? 3 : 15,
      textAlign: 'center',
      justifyContent: 'center',
      fontFamily: 'Rubik',
      border: `solid 0.7px ${colors.border_color}`,
      boxShadow: '0 0 2px 0 rgba(0, 0, 0, 0.1)',
      backgroundColor: colors.app_background_color,
      marginLeft: 3,
      marginRight: 3,
    },
  };
  return (
    <View style={myStyles.container}>
      <Text style={[textPrimary_13_0(globJSON, simPlatform), { fontFamily: null }]}>{price}</Text>
    </View>

  );
};
export default SingleSquareBtn;
